import {useState} from 'react'
import Table from 'components/ui/Table'
import Button from 'components/ui/Button'
import Spinner from 'components/ui/Spinner'
import AddOutlinedIcon from '@mui/icons-material/AddOutlined'
import {useGetClassesQuery} from 'services/classes'
import {Link, useNavigate} from 'react-router-dom'
import * as Styles from 'layouts/PrivateLayout.styles'
import Chip from '@mui/material/Chip'
import {trucktypes} from "../../../constants/trucktypes";

const TrucksModule = () => {
    const navigate = useNavigate()
    const columns = [
        {field: 'name', headerName: 'Truck'},
        {
            field: 'type', headerName: 'Type', render: (row: any) => {
                return trucktypes[row.truck_type ? 1 : 0]
            }
        },
        {
            field: 'locations',
            headerName: 'Locations',
            render: (row: { locations: any[] }) => (
                <div className="flex gap-2">
                    {row.locations.map((location) => (
                        <Chip
                            key={location.id}
                            label={`${location.name}`}
                            color="default"
                            size="small"
                        />
                    ))}
                </div>
            )
        }
    ]
    const [page, setPage] = useState(1)
    const [limit] = useState(10)

    const {
        data: trucksData,
        isLoading,
        isFetching
    } = useGetClassesQuery({page, limit})

    const handleDetailClick = (id: number) => {
        navigate(`/admin/trucks/${id}`)
    }

    return (
        <div>
            <Styles.PageTitleContainer>
                Trucks
                <Styles.PageTitleContainerButtons>
                    <Link to={'create'}>
                        <Button startIcon={<AddOutlinedIcon/>}>Add Truck</Button>
                    </Link>
                    {/*<Button onClick={() => navigate('/admin/export')}>Export CSV</Button>*/}
                </Styles.PageTitleContainerButtons>
            </Styles.PageTitleContainer>
            {!isLoading && !isFetching ? (
                <>
                    <Table
                        columns={columns}
                        rows={trucksData?.classes || []}
                        isFetching={isFetching || isLoading}
                        showPagination
                        page={page}
                        setPage={setPage}
                        onPrevPage={() => setPage(page - 1)}
                        onNextPage={() => setPage(page + 1)}
                        totalPages={Math.ceil(Number(trucksData?.records_count) / limit)}
                        onRowClick={handleDetailClick}
                        usePointer={true}
                    />
                </>
            ) : (
                <Spinner/>
            )}
        </div>
    )
}

export default TrucksModule
